<div class="listing" *ngIf="listing">


  <div [id]="'controls'+ (listing.id || listing._id)" class="carousel" data-bs-interval="false">
    <!-- <img  *ngIf="(listing.user)?.trusted_partner" class="gold-badge" src="assets/icons/gold-badge.png" tooltip="{{trustedString}}" /> -->
    <h4 *ngIf="listing?.is_external === true" class="pe-2 rating"> <span> {{starRating}} Star Hotel </span>
      <!-- <rating [(ngModel)]="rate" [max]="max" [readonly]="isReadonly" style="color: #FACA38"></rating> -->
    </h4>
    <h4 *ngIf="listing?.is_external === true && showBenchMark" class="pe-2 percentage"> <span>
        {{'-'+listing.property?.rent?.clooper_savings_percentage + '%'}} </span>
      <!-- <rating [(ngModel)]="rate" [max]="max" [readonly]="isReadonly" style="color: #FACA38"></rating> -->
    </h4>
    <span [ngClass]="listing.is_external === true ? 'external' : 'internal'" class=" propertyType  external">
      <p>{{listing.property_type?.replace('_', ' ') | titlecase}}</p>
    </span>

    <ol class="carousel-indicators" *ngIf="((listing.room || listing.property).images).length > 1">
      <li [attr.data-bs-target]="'#controls'+(listing.id || listing._id)"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index" [attr.data-bs-slide-to]="i"
        class=" {{(image?.is_default == true) ? 'active' : ''}}"></li>
    </ol>

    <div class="carousel-inner">
      <div
        (click)="listing?.is_external === true ? openRoomModal((listing.id || listing._id), listing.platform) : viewProperty(listing.id || listing._id)"
        *ngFor="let image of ((listing.room || listing.property).images); let i = index"
        class="image lozad carousel-item {{ (image?.is_default == true) ? 'active' : ''}}"
        [attr.data-background-image]="image.url | listingThumbnail">
        <img class="image w-100" [attr.data-src]="image.url" [alt]="(listing.room || listing.property).display_name" />
      </div>
      <button class="carousel-control-prev" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#controls'+(listing.id || listing._id)"
        (click)="carouselClicks('Webapp', (listing.room || listing.property).display_name)" data-bs-slide="prev">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowLeft"></fa-icon>
        <span class="visually-hidden">Previous</span>
      </button>

      <button class="carousel-control-next" type="button" *ngIf="((listing.room || listing.property).images).length > 1"
        [attr.data-bs-target]="'#controls'+(listing.id || listing._id)"
        (click)="carouselClicks('Webapp', (listing.room || listing.property).display_name)" data-bs-slide="next">
        <fa-icon class="fa-icon-md text-black" [icon]="icons.arrowRight"></fa-icon>
        <span class="visually-hidden">Next</span>
      </button>


    </div>

  </div>


  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center ">
      <div class="d-flex align-items-center sustainability" *ngIf="listing?.sustainable === true" >

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clip-path="url(#clip0_9005_2283)">
            <path d="M10 6L2.5 13.5" stroke="#005C14" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 12C0.999998 6.99996 5 1.99996 13.5 2.49996C14 11 9 15 4 12Z" stroke="#005C14" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_9005_2283">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>

        <span class="ml-3">Travel sustainably </span>
      </div>
      <!-- <div class="d-flex align-items-center sustainability" *ngIf="listing?.sustainable === true" >

        <fa-icon [icon]="icons.leave" class=" "></fa-icon>
        <span class="ml-3">{{'Travel Sustainable level ' + '  ' + listing.sustainability_level }} </span>
      </div> -->
    </div>

    <div>
      <span *ngIf="listing?.is_external !== true"
        (click)="toggleFavouriteProperty(listing.id || listing._id, favourite)">
        <img class="fav"
          src="{{!favourite ?  'assets/images/listings/unfavourite.svg' : 'assets/images/listings/favourite.svg'}}"
          alt="" alt="favourite icon">
      </span>
    </div>
  </div>

  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <p class="price"><span> FROM </span></p>
        <div *ngIf="listing?.is_external !== true">
          <p class="price">{{(listing.room || listing.property).rent?.amount | currency: listing.rent?.currency}}
            <span>{{listing.rent?.cycle |
              rentCycle }}</span></p>
        </div>
        <div class="price d-flex gap-2 align-items-end " *ngIf="listing?.is_external === true">
          <p class="mb-0 main" *ngIf="showBenchMark">
            {{(listing.room || listing.property).rent?.benchmark | currency: listing.rent?.currency}}</p>
          <p class="mb-0">
            {{(listing.room || listing.property).rent?.amount | currency: listing.rent?.currency}} </p>
          <span>{{listing.rent?.cycle |
            rentCycle }}</span>
        </div>
        <!-- <div class="d-flex">

          <img  *ngIf="(listing.user)?.trusted_partner" class="gold-badge" src="assets/icons/gold-badge.png" />
        </div> -->
      </div>
      <!-- <span *ngIf="listing?.is_external !== true"
        (click)="toggleFavouriteProperty(listing.id || listing._id, favourite)">
        <img class="fav"
          src="{{!favourite ?  'assets/images/listings/unfavourite.svg' : 'assets/images/listings/favourite.svg'}}"
          alt="" alt="favourite icon">
      </span> -->

    </div>
  </div>


  <a class="title" *ngIf="listing?.is_external !== true"
    (click)="viewProperty(listing.id || listing._id)">{{(listing.room ||
    listing.property).display_name}}</a>
           <img class="quality-tag " *ngIf="listing?.is_external !== true" [alt]="listing?.quality_tag" title={{listing?.quality_tag}} [src]="listing?.quality_tag === 'gold' ? 'assets/icons/GOLD.svg' : listing?.quality_tag === 'platinum' ? 'assets/icons/PLATINUM.svg' : listing?.quality_tag === 'silver' ? 'assets/icons/SILVER.svg': 'assets/icons/BRONZE.svg'" />
           
           <div class="d-flex align-items-center">
             <a class="title" *ngIf="listing?.is_external === true"
             (click)="openRoomModal((listing.id || listing._id),  listing.platform)">{{(listing.room ||
      listing.property).display_property_name}}</a>
      <img class="quality-tag " *ngIf="listing?.is_external === true" [alt]="listing?.quality_tag" title={{listing?.quality_tag}} [src]="listing?.quality_tag === 'gold' ? 'assets/icons/GOLD.svg' : listing?.quality_tag === 'platinum' ? 'assets/icons/PLATINUM.svg' : listing?.quality_tag === 'silver' ? 'assets/icons/SILVER.svg': 'assets/icons/BRONZE.svg'" />
       <!-- <img class="quality-tag " [alt]="listing?.quality_tag" title={{listing?.quality_tag}} [src]="listing?.quality_tag === 'gold' ? 'assets/icons/GOLD.svg' : listing?.quality_tag === 'platinum' ? 'assets/icons/PLATINUM.svg' : listing?.quality_tag === 'silver' ? 'assets/icons/SILVER.svg': 'assets/icons/BRONZE.svg'" /> -->
    <!-- <a class="title" *ngIf="listing?.is_external === true"
      (click)="openRoomModal(listing.id || listing._id)">{{(listing.room ||
      listing.property).display_title}}</a>  -->
  </div>


  <p class="star my-2" *ngIf="rate" > <span>{{rate}} </span> (Review ratings) </p>
  
  <div class="props">
    <span>
      <h6 *ngIf="(listing.property).guests_allowed">
        <span>{{(listing.property).guests_allowed}} Guests</span> <span class="dot-circle"></span>
      </h6>
      <h6 *ngIf="(listing.property).total_rooms">
        <fa-icon [icon]="icons.bed" class="black"></fa-icon>
        <span>{{ listing.is_external === true ? listing.total_beds : (listing.property).total_rooms}}</span> <span
          class="dot-circle"></span>
      </h6>
      <h6 *ngIf="(listing.property).bathrooms">
        <fa-icon [icon]="icons.bath" class="black"></fa-icon> <span>{{(listing.property).bathrooms}}</span> <span
          class="dot-circle"></span>
      </h6>
      

      <fa-icon [icon]="icons.map" class="black"></fa-icon>
      {{(listing.property?.address?.postcode || '') }}
      <!-- {{(listing.property?.address?.postcode || '') | postcode}} -->
    </span>
    <div class="props" *ngIf="(listing.distance)?.km">
      <span>

        <h6 >
            <fa-icon [icon]="icons.map" class="black"></fa-icon> <span>{{(listing.distance).km + 'km'}}</span> 
            
          </h6>
      </span>
    </div>
  </div>
</div>
